// Search actions
export const SEARCH_VEHICLES_BY_LICENSE_PLATE = 'SEARCH_VEHICLES_BY_LICENSE_PLATE';
export const SEARCH_VEHICLES_BY_LICENSE_PLATE_SUCCESS = 'SEARCH_VEHICLES_BY_LICENSE_PLATE_SUCCESS';
export const SEARCH_VEHICLES_BY_LICENSE_PLATE_ERROR = 'SEARCH_VEHICLES_BY_LICENSE_PLATE_ERROR';

// Get vehicle details
export const GET_VEHICLE = 'GET_VEHICLE';
export const GET_VEHICLE_SUCCESS = 'GET_VEHICLE_SUCCESS';
export const GET_VEHICLE_ERROR = 'GET_VEHICLE_ERROR';

// Create vehicle
export const CREATE_VEHICLE = 'CREATE_VEHICLE';
export const CREATE_VEHICLE_SUCCESS = 'CREATE_VEHICLE_SUCCESS';
export const CREATE_VEHICLE_ERROR = 'CREATE_VEHICLE_ERROR';

// Update vehicle
export const UPDATE_VEHICLE = 'UPDATE_VEHICLE';
export const UPDATE_VEHICLE_SUCCESS = 'UPDATE_VEHICLE_SUCCESS';
export const UPDATE_VEHICLE_ERROR = 'UPDATE_VEHICLE_ERROR';

// Link person to vehicle
export const LINK_PERSON_TO_VEHICLE = 'LINK_PERSON_TO_VEHICLE';
export const LINK_PERSON_TO_VEHICLE_SUCCESS = 'LINK_PERSON_TO_VEHICLE_SUCCESS';
export const LINK_PERSON_TO_VEHICLE_ERROR = 'LINK_PERSON_TO_VEHICLE_ERROR';

// Update person link (owner flag)
export const UPDATE_PERSON_LINK = 'UPDATE_PERSON_LINK';
export const UPDATE_PERSON_LINK_SUCCESS = 'UPDATE_PERSON_LINK_SUCCESS';
export const UPDATE_PERSON_LINK_ERROR = 'UPDATE_PERSON_LINK_ERROR';

// Unlink person from vehicle
export const UNLINK_PERSON = 'UNLINK_PERSON';
export const UNLINK_PERSON_SUCCESS = 'UNLINK_PERSON_SUCCESS';
export const UNLINK_PERSON_ERROR = 'UNLINK_PERSON_ERROR';

// Duplicate plate warning
export const SET_DUPLICATE_PLATE_WARNING = 'SET_DUPLICATE_PLATE_WARNING';
export const CLEAR_DUPLICATE_PLATE_WARNING = 'CLEAR_DUPLICATE_PLATE_WARNING';

// Get vehicles by student
export const GET_VEHICLES_BY_STUDENT = 'GET_VEHICLES_BY_STUDENT';
export const GET_VEHICLES_BY_STUDENT_SUCCESS = 'GET_VEHICLES_BY_STUDENT_SUCCESS';
export const GET_VEHICLES_BY_STUDENT_ERROR = 'GET_VEHICLES_BY_STUDENT_ERROR';

